import { Link } from "react-router-dom";
import { MapPin, Clock, Navigation, ArrowUpRight } from "lucide-react";

export const RouteCard = ({ route, index = 0 }) => {
    const hero_src = route.hero_image?.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${route.hero_image}` : route.hero_image;
    return (
        <Link
            to={`/routes/${route.slug}`}
            data-testid={`route-card-${route.slug}`}
            className="group block relative bg-[var(--card-bg)] border border-[var(--border-hair)] hover:border-[#E87722] transition-all duration-500 hover:-translate-y-1 fade-up"
            style={{ animationDelay: `${index * 80}ms` }}
        >
            <div className="relative aspect-[4/3] overflow-hidden">
                <img
                    src={hero_src}
                    alt={route.name}
                    className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
                <div className="absolute top-4 left-4 flex gap-2 flex-wrap">
                    <span className="px-3 py-1 bg-[#E87722] text-black font-display font-bold text-[10px] uppercase tracking-[0.2em]">
                        {route.category}
                    </span>
                    <span className="px-3 py-1 bg-black/60 backdrop-blur border border-white/20 text-[var(--fg)] font-display font-bold text-[10px] uppercase tracking-[0.2em]">
                        {route.difficulty}
                    </span>
                    {route.has_real_gpx && (
                        <span data-testid={`badge-real-gpx-${route.slug}`} className="px-3 py-1 bg-black/60 backdrop-blur border border-[#E87722] text-[#E87722] font-display font-bold text-[10px] uppercase tracking-[0.2em]">
                            ● Real GPX
                        </span>
                    )}
                </div>
                <div className="absolute bottom-4 right-4 w-11 h-11 bg-[#E87722] text-black flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <ArrowUpRight size={20} strokeWidth={2.5} />
                </div>
            </div>

            <div className="p-6">
                <div className="flex items-center gap-2 text-[var(--fg-muted)] text-xs font-body uppercase tracking-[0.2em] mb-2">
                    <MapPin size={12} className="text-[#E87722]" /> {route.region}
                </div>
                <h3 className="font-display font-black text-2xl uppercase leading-none tracking-tight text-[var(--fg)] group-hover:text-[#E87722] transition-colors">
                    {route.name}
                </h3>
                <p className="mt-3 text-[var(--fg-muted)] font-body text-sm leading-relaxed line-clamp-2">
                    {route.summary}
                </p>

                <div className="mt-5 pt-5 border-t border-[var(--border-hair)] grid grid-cols-2 gap-4">
                    <div className="flex items-center gap-2">
                        <Navigation size={14} className="text-[#E87722]" />
                        <div>
                            <div className="font-display font-black text-xl leading-none">{route.distance_km}</div>
                            <div className="text-[10px] uppercase tracking-[0.2em] text-[var(--fg-dim)] mt-1">km</div>
                        </div>
                    </div>
                    <div className="flex items-center gap-2">
                        <Clock size={14} className="text-[#E87722]" />
                        <div>
                            <div className="font-display font-black text-xl leading-none">{route.duration_hours}</div>
                            <div className="text-[10px] uppercase tracking-[0.2em] text-[var(--fg-dim)] mt-1">hours</div>
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    );
};
